import React from 'react';
import { NavLink } from 'react-router-dom';
const courses = [
    {
        title: "Ardent Computech Pvt Ltd",
        address: "SDF Building, Module #132, Ground Floor, GP Block, Sector V, Bidhannagar, Kolkata",
        program: "Online Learning Program: Data Science with Artificial Intelligence",
        fees: "9200",
        link: "/contact"
    },
    {
        title: "The Chennai School Of Banking and Management",
        address: "No.10, MMH Complex, Natesan St, T. Nagar, Chennai, Tamil Nadu 600017, India",
        program: "Online Learning Program: Banking Exam Training",
        fees: "15000",
        link: "/contact"
    },
    {
        title: "MARS Training And Solutions",
        address: "Aspiration, Kidwai Apartment, 2nd floor, 40/1, Rafi Ahmed Kidwai Road, Ripon St, opposite T",
        program: "Data Analytics Training For 12 Months - Regular",
        fees: "18000",
        link: "/contact"
    },
    {
        title: "Tech Institute of Learning",
        address: "45A, Park Street, New Delhi",
        program: "Full Stack Web Development Bootcamp",
        fees: "15000",
        link: "/enroll"
    },
    {
        title: "AI & ML Academy",
        address: "12, MG Road, Bengaluru",
        program: "Advanced Machine Learning and AI Techniques",
        fees: "18000",
        link: "/apply"
    },
    {
        title: "National Institute of Digital Marketing",
        address: "5th Block, Koramangala, Bengaluru, Karnataka",
        program: "Digital Marketing Certification Course",
        fees: "12000",
        link: "/contact"
    },
    {
        title: "Python Data Science Academy",
        address: "Banjara Hills, Hyderabad, Telangana",
        program: "Python for Data Science and Machine Learning",
        fees: "14000",
        link: "/contact"
    },
    {
        title: "Cloud Computing Institute",
        address: "Hadapsar, Pune, Maharashtra",
        program: "AWS & Azure Cloud Computing Master Course",
        fees: "20000",
        link: "/contact"
    },
    {
        title: "Institute of Cyber Security",
        address: "Cyber Hub, Gurgaon, Haryana",
        program: "Certified Ethical Hacking and Cyber Security",
        fees: "22000",
        link: "/enroll"
    },
    {
        title: "Blockchain Academy India",
        address: "Jayanagar, Bengaluru, Karnataka",
        program: "Blockchain Development and Cryptocurrency Training",
        fees: "25000",
        link: "/apply"
    }
];


const Institutes = () => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col p-0 m-0">
                        <div className='background_banner blog_banner'>
                            <h2>List of Top Institutes in India based on 2025 Rankings</h2>
                            <p>India is home to some of the world’s most prestigious institutes, offering top-quality education across various fields.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-4 mb-12">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                    {/* Desktop Header */}
                    <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-wider bg-gray-50">
                        <div className="col-span-4">Institute</div>
                        <div className="col-span-4">Program</div>
                        <div className="col-span-2">Fees</div>
                        <div className="col-span-2">Action</div>
                    </div>

                    {courses.map((course, index) => (
                        <React.Fragment key={index}>
                            {/* Mobile Card View */}
                            <div className="md:hidden bg-white border-b border-gray-100 last:border-0 p-5 relative">
                                <div className="mb-4">
                                    <h4 className="font-bold text-gray-900 text-lg mb-1">{course.title}</h4>
                                    <p className="text-xs text-gray-500 flex items-start gap-1">
                                        <i className="fa fa-map-marker mt-0.5"></i> {course.address}
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <p className="text-xs text-gray-400 uppercase font-bold mb-1">Program</p>
                                    <p className="text-sm text-gray-700 font-medium">{course.program}</p>
                                </div>

                                <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-3 mb-4">
                                    <div>
                                        <p className="text-[10px] text-gray-400 uppercase font-bold">Total Fees</p>
                                        <p className="text-sm font-bold text-green-600">₹{course.fees}/-</p>
                                    </div>
                                </div>

                                <NavLink to={course.link} className="block w-full bg-brand-orange text-white text-center font-bold py-3 rounded-lg hover:bg-orange-600 transition text-sm">
                                    Request a Callback
                                </NavLink>
                            </div>

                            {/* Desktop Row View */}
                            <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 hover:bg-orange-50/30 transition items-center">
                                <div className="col-span-4">
                                    <h4 className="font-bold text-gray-800 text-base mb-1">{course.title}</h4>
                                    <p className="text-xs text-gray-500 line-clamp-1" title={course.address}>
                                        <i className="fa fa-map-marker mr-1"></i> {course.address}
                                    </p>
                                </div>
                                <div className="col-span-4">
                                    <p className="text-sm text-gray-700 font-medium line-clamp-2">{course.program}</p>
                                </div>
                                <div className="col-span-2">
                                    <p className="font-bold text-green-600">₹{course.fees}/-</p>
                                </div>
                                <div className="col-span-2">
                                    <NavLink to={course.link} className="inline-block bg-brand-orange text-white text-xs font-bold px-4 py-2 rounded-lg hover:bg-orange-600 transition">
                                        Request Callback
                                    </NavLink>
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Institutes;
